import { useFormContext } from 'react-hook-form';
import PropTypes from 'prop-types';
import FormField from '@/components/common/form/FormField';
import FormFieldV2 from '../common/form/FormFieldV2';

import { useAppSelector } from '@/redux';
import { selectStoreId } from '@/redux/slices/root.slice';

import styles from './PrimeurPreferencesInputs.module.scss';
import { ERROR_TYPE, FIELD_TYPE } from '@/constants/form';
import { STORE_ID } from '@/constants/stores';
import { WARN_BY, WARN_BY_STATE } from '@/constants/primeur';

const PrimeurPreferencesInputs = ({ t }) => {
  const { watch } = useFormContext();

  const storeId = useAppSelector(selectStoreId);
  const isSMSAvailable = ![STORE_ID.SINGAPORE, STORE_ID.USA].includes(storeId);
  const warnList = isSMSAvailable ? WARN_BY : [WARN_BY[0]];

  const warnBy = watch('warnBy');
  const countryPhone = watch('countryPhone');

  const warnByOptions = Object.values(warnList).map((value) => ({
    label: t(`alert.${value}`),
    value
  }));

  return (
    <div className={styles.container}>
      <div className={styles.bloc}>
        <div className={styles['second-title']}>{t('alert.contactDetail')}</div>
        <FormFieldV2
          id="ti-primeur-alert-email"
          name="email"
          type={FIELD_TYPE.TEXT}
          label={t('forms.email')}
          validators={[ERROR_TYPE.REQUIRED, ERROR_TYPE.EMAIL]}
          required
        />
        <p className={styles.required}>
          {t('alert.emailIsRequired')}
        </p>
        {isSMSAvailable && (
          <FormFieldV2
            id="ti-primeur-alert-phone"
            name="tel"
            countryPhone={countryPhone}
            labelIndicator={t('forms.phoneIndicator')}
            type={FIELD_TYPE.PHONE}
            label={t('forms.phone')}
            validators={warnBy !== WARN_BY_STATE.EMAIL ? [ERROR_TYPE.REQUIRED, ERROR_TYPE.PHONE, ERROR_TYPE.ONLY_NUMBERS] : ['']}
            required={warnBy !== WARN_BY_STATE.EMAIL}
          />
        )}
      </div>
      <div className={styles.bloc}>
        <div className={styles['second-title']}>{t('alert.beAlertedBy')}</div>
        <FormField
          name="warnBy"
          type={FIELD_TYPE.RADIO}
          options={warnByOptions}
          isRequired
        />
      </div>
    </div>
  );
};

PrimeurPreferencesInputs.propTypes = {
  t: PropTypes.func.isRequired
};

export default PrimeurPreferencesInputs;
